import cookies from 'js-cookie'
import { getInsidedData } from '@insided/destination/utils/insidedDataStorage'
import globals from '../../utils/globals'

const controlEvents = [
  'Article Draft Created',
  'Article Published',
  'Article Scheduled',
  'Article Title Updated',
  'Article Version History Viewed',
  'Badge Awarded',
  'Badge Revoked',
  'Category Page Saved',
  'Contact Invited',
  'Content Sharing Settings Changed',
  'Create Freshdesk tickets from community posts disabled',
  'Create Freshdesk tickets from community posts enabled',
  'Create Productboard notes from community posts disabled',
  'Create Productboard notes from community posts enabled',
  'Create Salesforce cases from community posts disabled',
  'Create Salesforce cases from community posts enabled',
  'Create Zendesk tickets from community posts disabled',
  'Create Zendesk tickets from community posts enabled',
  'Custom View Opened',
  'Custom View Saved',
  'Custom View Shared',
  'Dashboard viewed',
  'Email Campaign Saved',
  'Email Campaign Sent',
  'Email Campaign Test Email Sent',
  'Escalate Post Clicked',
  'Escalation URL Clicked',
  'Event Created',
  'Export community member & activity data to Salesforce disabled',
  'Export community member & activity data to Salesforce enabled',
  'Freshdesk app installed',
  'Idea status assigned',
  'Ideation Data Exported',
  'Idea votes merged',
  'Import Salesforce Account data to inSided disabled',
  'Import Salesforce Account data to inSided enabled',
  'IP Information Clicked',
  'Post Edit Submitted',
  'Post Escalated',
  'Post Moved',
  'Post Moved Error',
  'Product board note created',
  'Reply Pinned',
  'Reply Unpinned',
  'Role Changed',
  'Salesforce app installed',
  'Salesforce federated search disabled',
  'Salesforce federated search enabled',
  'Skilljar app installed',
  'Skilljar federated search disabled',
  'Skilljar federated search enabled',
  'SSO Configuration Saved',
  'Team Note Saved',
  'Topic converted',
  'Topic Creation Success',
  'User Overview opened',
  'User Overview version switched',
  'Zapier API key generated',
  'Zap template clicked',
  'Zendesk app installed',
  'Zendesk federated search disabled',
  'Zendesk federated search enabled',
  'Zendesk measure your self-service score disabled',
  'Zendesk measure your self-service score enabled',
  '[Control] User Visited',
  'User bulk action applied',
  'Segment overview viewed',
  'Segment detail viewed',
  'Intercom app installed',
  'Intercom app uninstalled',
  'Intercom federated search disabled',
  'Intercom federated search enabled'
]

function getCookieData () {
  const cookieConfig = globals('cookieConfig')
  const cookieName = cookieConfig.name || 'cookiePrivacyLevel'
  const cookie = cookies.get(cookieName)


  const config = cookieConfig
  if (config.type !== 'json') {
    return cookie ? config.mapping[cookie] : globals('defaultCookieLevel')
  }

  let parsedCookie = {}
  try {
    parsedCookie = JSON.parse(cookie || '')
  } catch (e) {
    console.log('except ', e)
  }

  return config.mapping[parsedCookie[config.field || '']] || globals('defaultCookieLevel')
}

function trackEvent(eventName, eventPayload, cb) {
  const environment = globals('environment')
  const region = globals('region')
  const communityId = globals('communityId')
  const http = new window.XMLHttpRequest()

  if (!environment || !region || !communityId) {
    return cb && cb(null)
  }

  if (controlEvents.includes(eventPayload.type) || eventPayload.event_source === 'control') {
    const { userid } = getInsidedData('user')
    Object.assign(eventPayload, { userid, event_source: 'control' })
  } else {
    Object.assign(eventPayload, { event_source: 'destination' })
  }

  http.open('POST', globals('eventLogger'), true)
  http.withCredentials = true
  http.onreadystatechange = () => {
    if (http.readyState === 4) {
      if (http.status >= 200 && http.status < 400) {
        if (http.response) {
          const { visitor } = JSON.parse(http.response)
          const visitorCookie = cookies.get('tu')
          if ((!visitorCookie || visitorCookie !== visitor) && getCookieData() > 1) {
            cookies.set('tu', visitor, { expires: 365 })
          }
        }
        if (cb) return cb(null)
      }
      if (cb) return cb(new Error(http.responseText))
    }
  }
  const payload = JSON.stringify({
    ...eventPayload,
    eventName,
    communityId
  })

  if (environment === 'development') {
    console.log('Event logged:', { eventName, payload })
  }

  http.send(payload)
}

const tracker = { trackEvent }

export default tracker
